import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarsFilter } from '@fortawesome/pro-regular-svg-icons';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';

type ChainFiltersProps = {
  setSearch: (val: string) => void;
  hasReviews: boolean;
  setHasReviews: (val: boolean) => void;
  hasAdvisors: boolean;
  setHasAdvisors: (val: boolean) => void;
};

const ChainFilters: React.FC<ChainFiltersProps> = ({
  setSearch,
  hasReviews,
  setHasReviews,
  hasAdvisors,
  setHasAdvisors,  
}) => {
  return (
    <div className="sticky top-14 md:top-20">
      <h3 className="mb-4 flex items-center gap-2 text-xl font-bold text-black">
        <FontAwesomeIcon icon={faBarsFilter} className="text-blue" />
        Ketens filteren
      </h3>
      <form className="space-y-5">
        <div className="form-control pb-5 border-b separator-border-color">
          <label htmlFor="filter-on-name" className="filter-label">
            Op naam
          </label>
          <input
            type="text"
            id="filter-on-name"
            className="form-input"
            onChange={({ target }) => setSearch(target.value)}
          />
        </div>

        <fieldset className="form-control">
          <legend className="filter-label">
            Op categorie
          </legend>

          <div className="form-checkbox">
            <input
              type="checkbox"
              checked={hasReviews}
              onChange={(e) => setHasReviews(e.target.checked)}
              className="form-checkbox__input"
              id="filter-on-has-reviews"
            />
            <label
              htmlFor="filter-on-has-reviews"
              className="form-checkbox__label"
            >
              <FontAwesomeIcon icon={faCheck as IconProp} className="form-checkbox__check" />
              Heeft reviews
            </label>
          </div>

          <div className="form-checkbox">
            <input
              type="checkbox"
              checked={hasAdvisors}
              onChange={(e) => setHasAdvisors(e.target.checked)}
              className="form-checkbox__input"
              id="filter-on-has-advisors"
            />
            <label
              htmlFor="filter-on-has-advisors"
              className="form-checkbox__label"
            >
              <FontAwesomeIcon icon={faCheck as IconProp} className="form-checkbox__check" />
              Heeft adviseurs
            </label>
          </div>
        </fieldset>
      </form>
    </div>
  );
};

export default ChainFilters;